/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/breakpoint-change';
import './components/offcanvas';
import './components/delay-search-queries';
import './components/fancybox';
import './components/footer-menus';
import './components/scroll-to-top';
import './components/animate-details';
import { initDetailsAnimation } from './components/animate-details';

initDetailsAnimation();
